<template>
  <v-dialog
    :model-value="show"
    :max-width="maxWidth"
    :fullscreen="$vuetify.display.xs"
    :persistent="persistent"
    type="info"
    class="aboveBottomDialog"
  >
    <v-card :class="modalClass">
      <v-card-title mt-4>
        <v-row wrap>
          <v-col
            cols="12"
            class="text-h1 text-wrap text-center pb-2 mb-4 topSpacingForHeader font-weight-bold"
            aria-live="assertive"
          >
            {{ header }}
          </v-col>
        </v-row>
        <div class="fixed-top-alert">
          <AlertsComponent context="myaccount" />
        </div>
      </v-card-title>
      <v-card-text>
        <slot name="default" />
      </v-card-text>
      <v-card-actions>
        <v-row justify="center" class="mb-4">
          <v-col v-if="!showSendGrid" cols="10" class="text-center">
            <OnexButton
              v-if="showSaveButton"
              size="large"
              color="primary"
              class="btnWidth marginAuto mb-3"
              :id="saveChangesBtnId"
              @click="(removeAlerts('myaccount'), $emit('save'))"
              :loading="submitLoading"
              :disabled="!enableSaveButton"
            >
              {{ $t(submitBtnText) }}
            </OnexButton>
            <OnexButton
              v-if="showCloseButton"
              size="large"
              variant="outlined"
              color="outlined"
              class="btnWidth marginAuto mb-3"
              :id="closeBtnId"
              :class="closeBtnClass"
              @click="(removeAlerts('myaccount'), $emit('close'))"
            >
              {{ $t('L_close') }}
            </OnexButton>
          </v-col>
          <v-col v-else cols="10" class="text-center">
            <OnexButton
              color="primary"
              class="btnWidth marginAuto mb-3"
              :id="saveChangesBtnId"
              @click="(removeAlerts('myaccount'), $emit('save'))"
              :loading="submitLoading"
              :disabled="!enableSaveButton"
            >
              {{ $t('L_send_my_code') }}
            </OnexButton>
          </v-col>
          <v-col cols="12" class="pt-4 pb-4 mt-4 mb-4"> &nbsp; </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <!-- <v-dialog
    :model-value="show"
    :max-width="maxWidth"
    :fullscreen="$vuetify.display.xs"
    :persistent="persistent"
  >
    <v-card :class="modalClass">
      <v-card-text mt-4>
        <h2
          class="heading_two text-center pb-2 mb-4 topSpacingForHeader font-weight-bold"
          aria-live="assertive"
          v-html="header"
        />
        <div class="fixed-top-alert">
          <AlertsComponent context="myaccount" />
        </div>
      </v-card-text>
      <v-row mt2 class="pb-4">
        <v-col offset-xs1 cols="10">
          <slot name="content" />
          <v-row class="mb-4">
            <v-col class="text-center" v-if="!showSendGrid">
              <OnexButton
                v-if="showSaveButton"
                block
                color="primary"
                class="btnWidth marginAuto mb-3"
                :id="saveChangesBtnId"
                @click="(removeAlerts('myaccount'), $emit('save'))"
                :loading="submitLoading"
                :disabled="!enableSaveButton"
              >
                {{ $t(submitBtnText) }}
              </OnexButton>
              <OnexButton
                v-if="showCloseButton"
                block
                :color="closeIsActive ? 'primary' : 'secondary'"
                class="btnWidth marginAuto mb-3"
                :id="closeBtnId"
                :class="closeBtnClass"
                @click="(removeAlerts('myaccount'), $emit('close'))"
              >
                {{ $t('L_close') }}
              </OnexButton>
            </v-col>
            <v-col class="text-center" v-else>
              <OnexButton
                block
                color="primary"
                class="btnWidth marginAuto mb-3"
                :id="saveChangesBtnId"
                @click="(removeAlerts('myaccount'), $emit('save'))"
                :loading="submitLoading"
                :disabled="!enableSaveButton"
              >
                {{ $t('L_send_my_code') }}
              </OnexButton>
            </v-col>
            <v-col cols="12" class="pt-4 pb-4 mt-4 mb-4"> &nbsp; </v-col>
          </v-row>
        </v-col>
        <v-col />
      </v-row>
    </v-card>
  </v-dialog> -->
</template>
<script lang="ts">
import AlertsComponent from '@/components/AlertsComponent.vue';
import { useGlobalStore } from '@/stores/global/global.store';
import { mapActions, mapState, mapStores } from 'pinia';
import { defineComponent, type ComponentOptions } from 'vue';
import { OnexButton, OnexDialog } from '@primerica/onex-ui-lib';

const componentOptions: ComponentOptions = {
  name: 'MyAccountDialog',
  components: {
    AlertsComponent,
    OnexButton,
    OnexDialog,
  },
  props: {
    showSendGrid: {
      type: Boolean,
      required: false,
      default: false,
    },
    show: {
      type: Boolean,
      required: false,
      default: false,
    },
    header: {
      type: String,
      required: true,
    },
    enableSaveButton: {
      type: Boolean,
      default: false,
    },
    showSaveButton: {
      type: Boolean,
      required: false,
      default: true,
    },
    showCloseButton: {
      type: Boolean,
      required: false,
      default: true,
    },
    persistent: {
      type: Boolean,
      default: true,
    },
    modalClass: {
      type: String,
      required: false,
      default: '',
    },
    saveChangesBtnId: {
      type: String,
      required: false,
      default: 'saveId',
    },
    closeBtnId: {
      type: String,
      required: false,
      default: 'closeBtnId',
    },
    closeBtnClass: {
      type: String,
      required: false,
      default: 'mydialog_close',
    },
    closeIsActive: {
      type: Boolean,
      default: false,
    },
    maxWidth: {
      type: Number,
      required: false,
      default: 446,
    },
    submitBtnText: {
      type: String,
      required: false,
      default: 'L_save_changes',
    },
  },
  computed: {
    ...mapStores(useGlobalStore),
    ...mapState(useGlobalStore, { submitLoading: 'submitLoading' }),
  },
  methods: {
    ...mapActions(useGlobalStore, {
      removeAlerts: 'removeAlerts',
    }),
  },
};

export default defineComponent(componentOptions);
</script>

<style>
.topSpacingForHeader {
  margin-top: 40px;
}
.marginAuto {
  margin: auto !important;
}
.fixed-top-alert {
  position: absolute;
  width: 100%;
  left: 0;
}
.btnWidth {
  max-width: 300px;
  min-width: 300px;
  margin: auto;
}
.aboveBottomDialog {
  z-index: 10000 !important;
}
</style>
